import { renderComponent } from "./renderComponent";
export var renderNothing = renderComponent(null);
export default renderNothing;

//# sourceMappingURL=renderNothing.js.map



//////////////////
// WEBPACK FOOTER
// ./~/reassemble/lib/renderNothing.js
// module id = 61
// module chunks = 0